import { render } from "./Field.Switch.vue?vue&type=template&id=594c93fe&ts=true"
import script from "./Field.Switch.vue?vue&type=script&lang=ts"
export * from "./Field.Switch.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/admin/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__